export const getLocalStorageData = (keys: string[]) => {
    return keys.reduce((data: any, key: string) => {
        data[key] = localStorage.getItem(key);

        return data;
    }, {});
};
